import {Component, OnInit} from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import {FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms';
import 'rxjs/add/operator/switchMap';
import {UtilsService} from '../../services/utils.service';

export interface ConfirmDialogTermsModel {
  title: string;
  data: any;
  showCancelButton: boolean;
}

@Component({
  selector: 'app-confirmterms-dialog',
  templateUrl: './confirmterms-dialog.component.html',
  styleUrls: ['./confirmterms-dialog.component.css']
})
export class ConfirmDialogTermsComponent extends DialogComponent<ConfirmDialogTermsModel, boolean> implements OnInit {
  title: string;
  data: any;
  agreeTermsForm: FormGroup;


  constructor(dialogService: DialogService, private fb: FormBuilder, private utilsService: UtilsService) {
    super(dialogService);
  }

  ngOnInit() {
    setTimeout(function () {
            document.getElementsByTagName('body')[0].classList.add('modal-open');
    }, 310);
    if (this.data.message) {
        this.data.message = this.utilsService.decodeHtml(this.data.message);
    } else {
        this.data.message = 'There was an unexpected error.'
            + ' Please try again or contact <a href="mailto:support@openlm.com">support@openlm.com</a> if error persists.';
    }
    this.agreeTermsForm = this.fb.group({
        'agreeToEmails': [false],
        'agreeToConditions': [false]
    })
  }
  
  approve() {
    this.result = true;
    this.close();
  }

  ok() {
    this.result = true;
    this.close();
  }

  cancel() {
      this.result = false;
      this.close();
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/account/confirmterms/confirmterms-dialog.component.ts